import NavBar from "../../../utils/nav/NavBar";
import React, {useEffect, useState} from "react";
import ButtonAdd from "../../../utils/buttonAdd";
import Loading from "../../../utils/loading";
import {GetCategoriaProductos, UpdateCategoriaProductos} from "../../../../services/categoriasServices";


const CategoryEdit = ({category, onClose, onSave}) => {
    const [edit, setEdit] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const data = await GetCategoriaProductos(category?.nombre);
                setEdit({
                    ...data,
                    subCategorias: Array.isArray(data?.subCategorias) ? [...data.subCategorias] : []
                });
            } catch (error) {
                console.error("Error loading category:", error);
                alert(error?.message || "Error al cargar la categoría.");
                if (onClose) onClose();
            } finally {
                setLoading(false);
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category?.nombre]);


    const renumerarOrden = (subCategorias) => {
        return subCategorias
            .map((s, idx) => ({...s, orden: idx + 1}));
    };

    const handleAddSubCategoria = () => {
        const nombre = window.prompt("Nombre de la subcategoría:");
        if (!nombre) return;

        const current = Array.isArray(edit.subCategorias) ? [...edit.subCategorias] : [];
        const nextOrden = current.length > 0
            ? (Math.max(...current.map(s => Number(s.orden) || 0)) + 1)
            : 1;
        const newItem = {
            id: `temp-${Date.now()}`,
            nombre,
            orden: nextOrden
        };
        setEdit(prev => ({
            ...prev,
            subCategorias: [...current, newItem]
        }));
    };

    const handleMoveSubCategoria = (id, direction) => {
        // The UI renders a list sorted by `orden`, and the up/down buttons
        // enable/disable based on that sorted order. Ensure we also move items
        // using the same sorted order to avoid mismatches.
        const ordered = (Array.isArray(edit.subCategorias) ? edit.subCategorias : [])
            .slice()
            .sort((a, b) => (a.orden || 0) - (b.orden || 0));

        const idx = ordered.findIndex(s => s.id === id);
        if (idx === -1) return;

        if (direction === "up" && idx > 0) {
            [ordered[idx - 1], ordered[idx]] = [ordered[idx], ordered[idx - 1]];
        } else if (direction === "down" && idx < ordered.length - 1) {
            [ordered[idx + 1], ordered[idx]] = [ordered[idx], ordered[idx + 1]];
        } else {
            return;
        }

        const renumbered = renumerarOrden(ordered);
        setEdit(prev => ({...prev, subCategorias: renumbered}));
    };

    const handleRemoveSubCategoria = (id) => {
        const newList = edit.subCategorias.filter(s => s.id !== id);
        setEdit(prev => ({...prev, subCategorias: renumerarOrden(newList)}));
    };

    const handleRenameSubCategoria = (id) => {
        const target = edit.subCategorias.find(s => s.id === id);
        if (!target) return;
        const nuevoNombre = window.prompt("Editar nombre de la subcategoría:", target.nombre || "");
        if (nuevoNombre === null) return; // cancelado
        const nameTrim = String(nuevoNombre).trim();
        if (!nameTrim) return; // vacío
        const newList = edit.subCategorias.map(s => s.id === id ? {...s, nombre: nameTrim} : s);
        setEdit(prev => ({...prev, subCategorias: newList}));
    };

    const handleSave = async () => {
        try {
            await UpdateCategoriaProductos(edit);
            if (onSave) {
                onSave();
            }
        } catch (error) {
            console.error("Error saving category:", error);
            alert(error.message || "Error al guardar la categoría.");
        }
    }


    if (loading || !edit) {
        return (
            <div id="category-edit">
                <div className="page-header">
                    <NavBar
                        title="Editar Categoría de Producto"
                        navButtonComponent={
                            <i
                                className="fas fa-arrow-left nav-button-back"
                                onClick={() => onClose && onClose()}
                            />
                        }
                    />
                </div>
                <div className="page--content">
                    <Loading/>
                </div>
            </div>
        );
    }

    return (
        <div id="category-edit">
            <div className="page-header">
                <NavBar
                    title="Editar Categoría de Producto"
                    navButtonComponent={
                        <i
                            className="fas fa-arrow-left nav-button-back"
                            onClick={() => onClose()}
                        />
                    }
                />
                <div style={{display: "flex", alignItems: "center", justifyContent: "end"}}>
                    <button className="btn secondary" onClick={handleSave}>
                        Guardar
                    </button>
                </div>
            </div>
            <div className="page--content">
                <div className="card">
                    <h3>{edit.nombre}</h3>

                    <div style={{textAlign: "end"}}>
                        <ButtonAdd onClick={handleAddSubCategoria}/>
                    </div>

                    <div className="page-list">
                        {edit.subCategorias
                            .slice()
                            .sort((a, b) => (a.orden || 0) - (b.orden || 0))
                            .map((subCategoria, index) => (
                                <div key={subCategoria.id} className="card">
                                    <div className="row"
                                         style={{alignItems: "center", justifyContent: "space-between"}}>
                                        <div>
                                            <div style={{
                                                fontWeight: 600,
                                                fontSize: "1.5rem"
                                            }}>{subCategoria.nombre}</div>
                                        </div>
                                        <div style={{display: "flex", justifyContent: "end"}}>
                                            <button
                                                className="round-button secondary"
                                                title="Editar nombre"
                                                onClick={() => handleRenameSubCategoria(subCategoria.id)}
                                            >
                                                <i className="fas fa-pen"></i>
                                            </button>
                                            <button
                                                className="round-button"
                                                title="Subir"
                                                onClick={() => handleMoveSubCategoria(subCategoria.id, "up")}
                                                disabled={index === 0}
                                            >
                                                <i className="fas fa-arrow-up"></i>
                                            </button>
                                            <button
                                                className="round-button"
                                                title="Bajar"
                                                onClick={() => handleMoveSubCategoria(subCategoria.id, "down")}
                                                disabled={index === edit.subCategorias.length - 1}
                                                style={{marginLeft: 8}}
                                            >
                                                <i className="fas fa-arrow-down"></i>
                                            </button>
                                            <button
                                                className="round-button danger"
                                                title="Eliminar"
                                                onClick={() => handleRemoveSubCategoria(subCategoria.id)}
                                                style={{marginLeft: 8}}
                                            >
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>


            </div>

        </div>
    );

}

export default CategoryEdit;